import { graphql } from 'gatsby'
import React from 'react'

import { IndexQueryQuery } from '../../types/graphql-types'
import EnhancedMeta from '../components/meta/enhanced-meta'
import Layout from '../components/layout/layout'
import { generateLocalBusinessSchemaWithReviews } from '../utils/schema-generator'
import Slider from '../components/slider/slider'
import Appointment from '../components/appointment'
import About from '../components/about'

interface Props {
  data: IndexQueryQuery
  location: Location
}

const Index: React.FC<Props> = ({ data, location }: Props) => {
  const meta = data.site?.meta
  const localBusinessSchema = generateLocalBusinessSchemaWithReviews()

  return (
    <Layout location={location}>
      <EnhancedMeta
        title="Botox & Lip Fillers Cheshunt | 500+ 5★ Reviews | Ada Aesthetics"
        description="Professional Botox & anti-wrinkle injections in Cheshunt. Natural-looking results in 3-5 days. Experienced practitioners. Free consultation: 07478705252"
        keywords="botox Cheshunt, dermal fillers Cheshunt, lip fillers Cheshunt, aesthetic clinic Hertfordshire, anti-wrinkle injections"
        url="https://adaaesthetics.uk"
        schemaData={localBusinessSchema}
        site={meta}
      />
      <Slider location={location} />
      <div className="divider-90 d-none d-xl-block"></div>
      <div className="divider-20 d-xl-none"></div>
      <About />
      <div className="divider-90 d-none d-xl-block"></div>
      <div className="divider-20 d-xl-none"></div>
      <Appointment />
    </Layout>
  )
}

export default Index

export const pageQuery = graphql`
  query IndexQuery {
    site {
      meta: siteMetadata {
        title
        description
        siteUrl
        author
      }
    }
  }
`
